import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';

import { classListPropTypes } from 'constants/propTypes';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'components/Dropdown2';
import Message from 'components/Message';

const appointmentMessages = defineMessages({
  label: {
    id: 'ratings.class-filter.label-appointments',
    defaultMessage: 'Appointments',
  },
  allClasses: {
    id: 'ratings.class-filter.all-appointments',
    defaultMessage: 'All appointments',
  },
});

const classMessages = defineMessages({
  label: {
    id: 'ratings.class-filter.label-classes',
    defaultMessage: 'Classes',
  },
  allClasses: {
    id: 'ratings.class-filter.all-classes',
    defaultMessage: 'All classes',
  },
});

const orderMessages = defineMessages({
  label: {
    id: 'ratings.class-filter.label-orders',
    defaultMessage: 'Orders',
  },
  allClasses: {
    id: 'ratings.class-filter.all-orders',
    defaultMessage: 'All orders',
  },
});

const sessionMessages = defineMessages({
  label: {
    id: 'ratings.class-filter.label-sessions',
    defaultMessage: 'Sessions',
  },
  allClasses: {
    id: 'ratings.class-filter.all-sessions',
    defaultMessage: 'All sessions',
  },
});

const RatingsClassFilter = ({
  classes,
  offersAppointments,
  offersClasses,
  selectedClassId,
  updateClass,
  isVenueFoodAndBeverage,
}) => {
  let messages = sessionMessages;
  if (isVenueFoodAndBeverage) {
    messages = orderMessages;
  } else if (offersAppointments && !offersClasses) {
    messages = appointmentMessages;
  } else if (offersClasses && !offersAppointments) {
    messages = classMessages;
  }

  const options = [
    {
      id: null,
      name: <Message message={messages.allClasses} />,
    },
    ...classes,
  ];
  const { name: selectedClassName } = options.find(({ id }) => id === selectedClassId) || options[0];

  return (
    <Dropdown attachment="left" dataCypress="ratings-class-filter">
      <DropdownToggle label={messages.label} isActive={!!selectedClassId}>
        {selectedClassName}
      </DropdownToggle>
      <DropdownMenu>
        {options.map(({ id, name }) => (
          <DropdownItem key={id || 'all-classes'} isSelected={id === selectedClassId} onClick={() => updateClass(id)}>
            {name}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

RatingsClassFilter.propTypes = {
  classes: classListPropTypes,
  offersAppointments: PropTypes.bool,
  offersClasses: PropTypes.bool,
  selectedClassId: PropTypes.number,
  updateClass: PropTypes.func,
  isVenueFoodAndBeverage: PropTypes.bool,
};

export default RatingsClassFilter;
